<div class="dialog-main">
  <div class="header">
    <span class="modal-title">
      {{ "REMOVE_USER_FROM_UNIT_TITLE" | translate }}
    </span>
    <img
      src="/assets/svg/ico-hamburger-close.svg"
      class="pointer-cursor close-btn"
      (click)="cancel()"
    />
  </div>

  <div class="body-container">
    <p class="question text-center">
      {{ "ARE_YOU_SURE_YOU_WANT_TO_CONTINUE" | translate }}
    </p>
    <p class="message text-center">
      {{ "REMOVE_USER_FROM_UNIT_DESC" | translate }}
    </p>

    <div class="info-box d-flex align-items-start">
      <img
        src="/assets/svg/ico-info-blue.svg"
        class="info-icon mr-2"
        alt="info"
      />
      <span class="info-text">
        {{ "REMOVE_USER_FROM_UNIT_PHYSICAL_NOTE" | translate }}
      </span>
    </div>
  </div>

  <div class="footer">
    <button
      class="btn btn-danger done-btn w-100"
      type="button"
      (click)="removeUser()"
    >
      {{ "CONTINUE" | translate }}
    </button>
    <button type="button" (click)="cancel()" class="add-button w-100">
      <strong>{{ "CANCEL" | translate }}</strong>
    </button>
  </div>
</div>
